import * as _ from 'lodash-es';
import { AdminKeySpaceList } from '../model/adminKeySpace-list';
import { AdminKeySpaceBuilder } from './adminKeySpace-builder';
export class AdminKeySpaceListBuilder {
    static buildAdminKeySpaceList(data) {
        const adminKeySpaceList = new AdminKeySpaceList();
        adminKeySpaceList.pagination = data.pagination;
        adminKeySpaceList.page = data.page;
        adminKeySpaceList.total = data.total;
        adminKeySpaceList.totalPages = data.totalPages;
        adminKeySpaceList.keySpaces = _.map(data.key_spaces, (keySpace) => {
            return AdminKeySpaceBuilder.buildKeySpace(keySpace);
        });
        return adminKeySpaceList;
    }
}
//# sourceMappingURL=adminKeySpace-list-builder.js.map